/* eslint-disable react/display-name */
import React, { lazy, memo } from "react";

const SmartLockPage = lazy(() => import("./pages/manage"));
const SmartLockAdminPage = lazy(() => import("./pages/admin-manage"));
const LockerVtvPage = lazy(() => import("./pages/locker-vtv"));
const CameraLockerVtvPage = lazy(() => import("./pages/camera-locker-vtv"));
const LockerModulePage = lazy(() => import("./pages/locker-module"));
const SmartlockLogPage = lazy(() => import("./pages/camera-logs"));

const SmartLockRoutes = [
  { path: "manage", element: <SmartLockPage /> },
  { path: "admin-manage", element: <SmartLockAdminPage /> },
  { path: "locker-vtv", element: <LockerVtvPage /> },
  { path: "camera-locker-vtv", element: <CameraLockerVtvPage /> },
  { path: "module-type", element: <LockerModulePage /> },
  { path: "image-logs", element: <SmartlockLogPage /> },
];
export default SmartLockRoutes;
